import { render, staticRenderFns } from "./ScrollTrigger.vue?vue&type=template&id=724c8171&scoped=true&"
import script from "./ScrollTrigger.vue?vue&type=script&lang=js&"
export * from "./ScrollTrigger.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTrigger.vue?vue&type=style&index=0&id=724c8171&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c8171",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724c8171')) {
      api.createRecord('724c8171', component.options)
    } else {
      api.reload('724c8171', component.options)
    }
    module.hot.accept("./ScrollTrigger.vue?vue&type=template&id=724c8171&scoped=true&", function () {
      api.rerender('724c8171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ScrollTrigger.vue"
export default component.exports